import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, InjectionToken, Input, Provider, Type, inject } from '@angular/core';

import { type DefaultLoadingScreenComponent } from './default-loading-screen.component';

export const LoadingComponentToken = new InjectionToken<DefaultLoadingScreenComponent & Type<any>>('LoadingComponentToken');

export function provideLoadingComponent(component: typeof DefaultLoadingScreenComponent): Provider {
    return { provide: LoadingComponentToken, useValue: component };
}

@Component({
    selector: 'loading-screen',
    template: `
        <ng-container
            *ngComponentOutlet="
                loaderComponent;
                inputs: {
                    templateType: templateType,
                    isUsedFromWidget: isUsedFromWidget,
                    displayed: displayed,
                    skeletonOnlyDisplayed: skeletonOnlyDisplayed,
                    longRenderView: longRenderView,
                    skeletonOnly: skeletonOnly,
                    onlySpinner: onlySpinner,
                    isFullPage: isFullPage,
                }
            " />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgComponentOutlet],
})
export class LoadingScreenComponent {
    @Input() templateType: string = 'GENERIC';
    @Input() isUsedFromWidget: boolean = false;
    @Input() displayed: boolean = false;
    @Input() skeletonOnlyDisplayed: boolean = false;
    @Input() longRenderView: boolean = false;
    @Input() skeletonOnly: boolean = false;
    @Input() onlySpinner: boolean = false;
    @Input() isFullPage: boolean = false;

    loaderComponent = inject(LoadingComponentToken);
}
